<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-th-list"></i> {{ _('Audit log') }}</h3>
        </div>
        <div class="col-md-12">
          <DatePicker :tz="Intl.DateTimeFormat().resolvedOptions().timeZone" :shortLocale="shortLocale" v-model="startTime" :placeholder="_('Start date')" :time-picker="true" :time-picker-inline="true" style="width: 200px" />
          <button class="btn btn-info" type="button" v-if="clientFilter" v-on:click="filterClient(null)"><i class="fa fa-fw fa-times"></i> {{ _('User interface') }}: {{ this.clientFilter.name }}</button>
          <button class="btn btn-info" type="button" v-if="sessionFilter" v-on:click="filterSession(null)"><i class="fa fa-fw fa-times"></i> {{ _('Session') }}: {{ this.sessionFilter }}</button>
          <button class="btn btn-info" type="button" v-if="userFilter" v-on:click="filterUser(null)"><i class="fa fa-fw fa-times"></i> {{ _('User') }}: {{ this.userFilter.name }}</button>
          <button class="btn btn-info" type="button" v-if="targetFilter" v-on:click="filterTarget(null)"><i class="fa fa-fw fa-times"></i> {{ getTargetTitle(this.targetFilter.type) }}<template v-if="this.targetFilter.id"> {{ this.targetFilter.id }}</template></button>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>{{ _('Time') }} <i class="fa fa-fw fa-up" v-if="!startTime"></i><i v-else class="fa fa-fw fa-down"></i></th>
            <th>{{ _('User') }}</th>
            <th>{{ _('Session') + ' / ' + _('User interface') }}</th>
            <th>{{ _('Context') }}</th>
            <th>{{ _('Target') }}</th>
            <th>{{ _('Target ID') }}</th>
            <th>{{ _('Action') }}</th>
            <th>{{ _('References') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries">
            <td>{{ DateTime.fromSeconds(Number(entry.ts)).toFormat(dateFormat + ' ' + timeFormat.replace(/mm/, 'mm:ss')) }}</td>
            <td><a href="javascript:;" v-if="entry.user" v-on:click="filterUser(entry.user)">{{ getUserName(entry) }}</a></td>
            <td><a href="javascript:;" v-if="entry.client" v-on:click="filterClient({ identifier: entry.client, name: entry.client_name })">{{ entry.client_name ? entry.client_name : entry.client }}</a><a href="javascript:;" v-else-if="entry.session" v-on:click="filterSession(entry.session)">{{ entry.session }}</a></td>
            <td>{{ entry.context }}</td>
            <td><a href="javascript:;" v-if="entry.target" v-on:click="filterTarget(entry.target)"><i v-if="getTargetIcon(entry.target)" :class="'fa fa-fw fa-' + getTargetIcon(entry.target)"></i> {{ getTargetTitle(entry.target) }}</a></td>
            <td><a href="javascript:;" v-if="entry.target_id" v-on:click="filterTarget(entry.target, entry.target_id)">{{ entry.target_id }}</a></td>
            <td :class="'action-' + entry.action"><i v-if="getActionIcon(entry.action)" :class="'fa fa-fw fa-' + getActionIcon(entry.action)"></i> {{ getActionTitle(entry.action) }}</td>
            <td><button class="btn btn-xs btn-default" type="button" v-for="ref in parseRefs(entry.refs)" v-on:click="filterTarget(ref.target, ref.target_id)"><i v-if="ref.icon" :class="'fa fa-fw fa-' + ref.icon"></i><template v-else>{{ ref.target }}:</template> {{ ref.target_id }}</button>
            <button class="btn btn-xs btn-default" v-if="numRefs(entry.refs) > maxRefs" v-on:click="showAllRefs">...</button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9" v-if="startTime && entries.length === 100"><button class="btn btn-info" type="button" v-on:click="loadMore"><i class="fa fa-fw fa-forward"></i> {{ _('Show more') }}</button></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import DatetimePicker from '~/components/DatetimePicker'

export default {
  mixins: [components],
  data () {
    return {
      DateTime: DateTime,
      entries: [],
      clientFilter: null,
      sessionFilter: null,
      userFilter: null,
      targetFilter: null,
      startTime: null,
      maxRefs: 8
    }
  },
  methods: {
    async loadMore () {
      if (this.entries[this.entries.length - 1]) {
        this.startTime = DateTime.fromSeconds(Number(this.entries[this.entries.length - 1].ts)).toJSDate()
      }
    },
    async load () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/auditlog.json?apikey=' + this.apiKey + this.filterStr)
      } catch(e) {
        return
      }
      this.entries = response.data
    },
    numRefs (refs) {
      if (refs && refs.split) {
        return refs.split(',').length
      }
      return 0
    },
    parseRefs (refs) {
      if (!refs) {
        return []
      }
      let ret = []
      const refArr = refs.split(',')
      let i = 0
      refArr.forEach((refStr) => {
        const retValues = refStr.split(':')
        if (retValues.length === 2 && i++ < this.maxRefs) {
          ret.push({
            target: retValues[0],
            target_id: retValues[1],
            icon: this.getTargetIcon(retValues[0])
          })
        }
      })
      return ret
    },
    showAllRefs () {
      this.maxRefs = 99999999
    },
    getTargetIcon(target) {
      switch (target) {
        case 'item':
          return 'shopping-bag'
        case 'product':
          return 'cubes'
        case 'resource':
          return 'cube'
        case 'basket':
          return 'shopping-basket'
        case 'reservation':
          return 'clock-o'
        case 'productreservation':
          return 'clock-o'
        case 'order':
          return 'shopping-cart'
        case 'bill':
          return 'file'
        case 'seat':
          return 'user-circle'
        case 'delivery':
          return 'truck'
        case 'show':
          return 'film'
        case 'ticket':
          return 'ticket'
        case 'user':
          return 'user'
      }
      return null
    },
    getTargetTitle(target) {
      switch (target) {
        case 'item':
          return this._('Item')
        case 'product':
          return this._('Product')
        case 'resource':
          return this._('Resource')
        case 'basket':
          return this._('Basket')
        case 'reservation':
          return this._('Reservation')
        case 'productreservation':
          return this._('Product reservation')
        case 'order':
          return this._('Order')
        case 'bill':
          return this._('Invoice')
        case 'seat':
          return this._('Seat')
        case 'delivery':
          return this._('Delivery')
        case 'show':
          return this._('Show')
        case 'ticket':
          return this._('Ticket')
        case 'user':
          return this._('User')
      }
      return target
    },
    getActionIcon(action) {
      switch(action) {
        case 'create':
          return 'plus'
        case 'update':
          return 'pencil'
        case 'delete':
          return 'trash'
        case 'refresh':
          return 'refresh'
        case 'print':
          return 'print'
        case 'converttobill':
          return 'file'
        case 'login':
          return 'sign-in'
        case 'logout':
          return 'sign-out'
      }
      return null
    },
    getActionTitle(action) {
      switch(action) {
        case 'create':
          return this._('Create')
        case 'update':
          return this._('Modify')
        case 'delete':
          return this._('Delete')
        case 'refresh':
          return this._('Refresh')
        case 'print':
          return this._('Print')
        case 'converttobill':
          return this._('Transaction')
        case 'login':
          return this._('Login')
        case 'logout':
          return this._('Logout')
      }
      return action
    },
    getUserName(entry) {
      if (entry && entry.user) {
        return entry.user.name
      }
      return ''
    },
    filterClient(client) {
      this.clientFilter = client
      this.sessionFilter = null
    },
    filterSession(session) {
      this.sessionFilter = session
      this.clientFilter = null
    },
    filterUser(user) {
      this.userFilter = user
    },
    filterTarget(type = null, id = null) {
      if (!type) {
        this.targetFilter = null
      } else {
        this.targetFilter = {
          type, 
          id
        }
      }
    },
    clearFilters() {
      this.clientFilter = null
      this.sessionFilter = null
      this.userFilter = null
      this.targetFilter = null
    }
  },
  computed: {
    filterStr () {
      return (this.clientFilter  ? '&client_id=' + this.clientFilter.identifier : '') +
             (this.sessionFilter ? '&session_id=' + this.sessionFilter : '') + 
             (this.userFilter ? '&user_id=' + this.userFilter.id : '') +
             (this.targetFilter ? '&target_type=' + this.targetFilter.type + (this.targetFilter.id ? '&target_id=' + this.targetFilter.id : '') : '') + 
             (this.startTime ? '&ts=' + DateTime.fromJSDate(this.startTime).toUnixInteger() : '')
    }
  },
  watch: {
    filterStr () {
      this.load()
    }
  },
  components: {
    DatetimePicker
  },
  created () {
    this.load()
  }
}
</script>

<style scoped>
.action-create {
  color: #4f792b;
}
.action-delete{
  color: #cd1e1a;
}
.action-update {
  color: #00b8d4;
}
.action-refresh {
  color: gray;
}
</style>